// extracted by mini-css-extract-plugin
export default {"tableContainer":"rates_table_tableContainer__fgEds"};